var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-row", [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c("card", { staticClass: "stacked-form" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmit($event)
                }
              }
            },
            [
              _vm._l(_vm.lines, function(line, index) {
                return _c(
                  "b-row",
                  { key: index, staticClass: "ml-0 mr-0 mb-5 mt-3" },
                  [
                    _c("b-col", { attrs: { md: "10 p-2" } }, [
                      _c("h4", [_c("strong", [_vm._v("List Item")])])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { md: "1 p-0 mt-3 text-center" } }, [
                      index >= 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.removeLine(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-times" })]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "1 p-0 mt-3 text-center" } },
                      [
                        index + 1 === _vm.lines.length
                          ? _c(
                              "b-button",
                              {
                                attrs: { type: "button", variant: "primary" },
                                on: { click: _vm.addLine }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "plus" }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("fg-input", { attrs: { label: "Product" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group input-typeahead",
                              class:
                                _vm.productError !== null ? "has-error" : ""
                            },
                            [
                              _c("typeahead", {
                                ref: "userProfileUuidTypeahead",
                                refInFor: true,
                                attrs: {
                                  customQueryParamName: "name",
                                  labelFields: ["product_name"],
                                  placeholder: "Cari Product",
                                  urlSearch: _vm.apiUrl.productSearch,
                                  "arr-response": "data",
                                  dataLineIndex: index,
                                  model: line.product,
                                  formType: "productSearch"
                                },
                                on: { doCreateCutomer: _vm.getSize }
                              }),
                              _vm._v(" "),
                              _vm.productError !== null
                                ? _c("p", {
                                    staticClass: "error",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.productError)
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    line.productSize.length !== 0
                      ? _c("b-col", { attrs: { mf: "12" } }, [
                          _c(
                            "table",
                            {
                              staticClass: "table table-bordered table-striped"
                            },
                            [
                              _c("tr", [
                                _c("th", { attrs: { width: "100" } }, [
                                  _vm._v("Varian")
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "150" } }, [
                                  _vm._v("Persedian")
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "250" } }, [
                                  _vm._v("Alasan")
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "250" } }, [
                                  _vm._v("Stok Saat Ini")
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "100" } })
                              ]),
                              _vm._v(" "),
                              _vm._l(line.productSize, function(productSize) {
                                return _c("tr", { key: productSize.id }, [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        productSize.size !== null
                                          ? productSize.size.name
                                          : "-"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(productSize.stock))]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c("treeselect", {
                                        staticClass: "mb-3",
                                        attrs: {
                                          placeholder: "Pilih kategori",
                                          multiple: false,
                                          "clear-on-select": true,
                                          options: _vm.reasonList,
                                          name: "reason",
                                          "data-vv-as": "reason"
                                        },
                                        model: {
                                          value: productSize.reason,
                                          callback: function($$v) {
                                            _vm.$set(productSize, "reason", $$v)
                                          },
                                          expression: "productSize.reason"
                                        }
                                      }),
                                      _vm._v(" "),
                                      productSize.isError &&
                                      productSize.reason === undefined
                                        ? _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                "Alasan tidak boleh kosong"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "number",
                                          placeholder:
                                            "Masukkan jumlah pengurangan"
                                        },
                                        model: {
                                          value: productSize.return,
                                          callback: function($$v) {
                                            _vm.$set(productSize, "return", $$v)
                                          },
                                          expression: "productSize.return"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      productSize.return
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  productSize.return -
                                                    productSize.stock <
                                                  0
                                                    ? "text-danger"
                                                    : "text-success"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    productSize.return -
                                                      productSize.stock <
                                                    0
                                                      ? ""
                                                      : "+"
                                                  ) +
                                                    _vm._s(
                                                      productSize.return -
                                                        productSize.stock
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        : [_vm._v("0")]
                                    ],
                                    2
                                  )
                                ])
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("cancel-button", { staticClass: "text-right" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "float-button-right" },
                [
                  _c("save-data-button", {
                    attrs: {
                      disabled: _vm.saveButtonData.isLoading,
                      "is-create": _vm.$route.params.id === undefined,
                      state:
                        _vm.saveButtonData.isLoading &&
                        _vm.saveButtonData.state === 1
                          ? 2
                          : _vm.saveButtonData.state,
                      "is-loading": _vm.saveButtonData.isLoading
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-345dd074", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-345dd074","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/StockIn/FormStockReturn.vue
// module id = iOJ+
// module chunks = 4